export const altVersion = "¯\\_(ツ)_/¯";
